import { BaseGeoLocation } from './base-geo-location';
import {UserRoleRef} from './user-role-ref';

export class DistributorRef {
    id: number;
    name: string;
    code: string;
    imageUrl?: string;
    designation?: string;
    role?: UserRoleRef;
    latitude?: number;
    longitude?: number;
    address?: string;
}
